// import isEqual from 'lodash/isEqual';
// import { useState, useCallback, useEffect, useContext } from 'react';
// import Card from '@mui/material/Card';
// import Table from '@mui/material/Table';
// import Button from '@mui/material/Button';
// import Container from '@mui/material/Container';
// import TableContainer from '@mui/material/TableContainer';
// import { paths } from 'src/routes/paths';
// import { useRouter } from 'src/routes/hooks';
// import { _userList, _roles, USER_STATUS_OPTIONS } from 'src/_mock';
// import { useGetFacility } from 'src/api/facilityapi';
// import { useBoolean } from 'src/hooks/use-boolean';
// import Scrollbar from 'src/components/scrollbar';
// import { ConfirmDialog } from 'src/components/custom-dialog';
// import { useSettingsContext } from 'src/components/settings';
// import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
// import {
//   useTable,
//   getComparator,
//   emptyRows,
//   TableNoData,
//   TableEmptyRows,
//   TableHeadCustom,
//   TablePaginationCustom,
//   TableSkeleton,
// } from 'src/components/table';
// // types
// import {
//   TableHead,
//   TableRow,
//   TableCell,
//   TableSortLabel,
//   Stack,
//   TextField,
//   Tooltip,
// } from '@mui/material';
// import { IUserTableFilterValue, IUserTableFilters } from 'src/types/user';
// import { useSnackbar } from 'notistack';
// import TableBody from '@mui/material/TableBody';
// import { facility } from 'src/types/product';
// import FacilityTable from 'src/sections/product/view/facility-table-row';
// import axiosInstance, { endpoints } from 'src/utils/axios';
// import InputBase from '@mui/material/InputBase';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import SearchIcon from '@mui/icons-material/Search';
// import { errorMsg, modules, permissions } from 'src/api/constant';
// import { AuthContext } from 'src/auth/context/jwt';
// import { Box } from '@mui/system';
// import 'src/css/style.css';
// import Iconify from 'src/components/iconify/iconify';

// const TABLE_HEAD = [
//   // { id: 'sr', label: 'Sr.no' },
//   { id: 'name', label: 'Name' },
//   { id: 'email', label: 'Email' },
//   { id: 'date', label: 'Start Date' },
//   // { id: 'status', label: 'Status', width: 300 },
//   { id: 'action', label: 'Inactive/Active' },
// ];
// type SortDirection = 'asc' | 'desc';

// const defaultFilters: IUserTableFilters = {
//   name: '',
//   role: [],
//   status: 'all',
// };

// // ----------------------------------------------------------------------

// export default function AppUserFacilityView() {
//   const table = useTable();
//   const [currentTab, setCurrentTab] = useState('profile');
//   const { enqueueSnackbar } = useSnackbar();
//   const [newshowdata, setNewshowdata] = useState(false);
//   const [neworderdata, setNeworderdata] = useState(false);
//   const [filterdata, setFilterdata] = useState('');

//   const [order, setOrder] = useState<SortDirection>('asc');
//   const [orderBy, setOrderBy] = useState<string | undefined>(undefined);
//   const [sorting, setSorting] = useState(false);
//   const settings = useSettingsContext();
//   const { user } = useContext(AuthContext);

//   const users = user && user;
//   const router = useRouter();

//   const { facilitydata, productsLoading, total } = useGetFacility(table.page + 1);

//   const confirm = useBoolean();

//   const [tableData, setTableData] = useState<facility[]>([]);

//   // useEffect(() => {
//   //   if (facilitydata.length) {
//   //     setTableData(facilitydata);
//   //   }
//   // }, [facilitydata]);

//   useEffect(() => {
//     if (facilitydata?.length) {
//       if (table.page === 0) {
//         setTableData(facilitydata);
//       } else {
//         setTableData((prevData) => [...prevData, ...facilitydata]);
//       }
//     }
//   }, [facilitydata, table.page]);

//   // useEffect(() => {
//   //   if (facilitydata?.length) {
//   //     // If it's the first page, set the data directly
//   //     if (table.page === 0) {
//   //       setTableData(facilitydata);
//   //     } else {
//   //       // If it's not the first page, clear existing data and append new data
//   //       setTableData((prevData) => [...prevData, ...facilitydata]);
//   //     }
//   //   }
//   // }, [facilitydata, table.page]);

//   const [filters, setFilters] = useState(defaultFilters);

//   const dataFiltered = applyFilter({
//     inputData: tableData,
//     comparator: getComparator(table.order, table.orderBy),
//     filters,
//   });

//   const dataInPage = dataFiltered.slice(
//     table.page * table.rowsPerPage,
//     table.page * table.rowsPerPage + table.rowsPerPage
//   );

//   const denseHeight = table.dense ? 52 : 72;

//   const canReset = !isEqual(defaultFilters, filters);

//   const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

//   const handleDeleteRow = useCallback(
//     (id: string) => {
//       const deleteRow = tableData.filter((row) => row.user_id !== id);
//       setTableData(deleteRow);

//       table.onUpdatePageDeleteRow(dataInPage.length);
//     },
//     [dataInPage.length, table, tableData]
//   );

//   const handleViewRow = useCallback(
//     (id: string) => {
//       router.push(paths.dashboard.user.viewfacilityappuserdetails(id));
//     },
//     [router]
//   );
//   const handleEditRow = useCallback(
//     (id: string) => {
//       router.push(paths.dashboard.user.editfacilityappuserdetails(id));
//     },
//     [router]
//   );
//   const handleFilters = useCallback(
//     (name: string, value: IUserTableFilterValue) => {
//       table.onResetPage();
//       setFilters((prevState) => ({
//         ...prevState,
//         [name]: value,
//       }));
//     },
//     [table]
//   );

//   const handleupdatestatus = async (id: any, user_type: any) => {
//     if (!users) {
//       enqueueSnackbar('Something went wrong', { variant: 'error' });
//       return;
//     }
//     if (!users[modules.account_type_facility].includes(permissions.UPDATE)) {
//       enqueueSnackbar(errorMsg, { variant: 'error' });
//       return;
//     }
//     try {
//       const res = await axiosInstance.put(
//         `${endpoints.facility.statusfacility}?user_id=${id}&user_type=${user_type}`
//       );
//       // console.log("bxzbcmzxb",  res)
//       const details = res.data.results;
//       const detail = details.map((item: any) => item.user_id);
//       const newstatus = details.map((item: any) => item.is_approved);

//       const newd = JSON.parse(detail);
//       const newdstatus = JSON.parse(newstatus);

//       if (newdstatus === true) {
//         enqueueSnackbar('Account activated. All related account types are now active.');
//       } else if (newdstatus === false) {
//         enqueueSnackbar('Account deactivated. All related account types are now inactive.');
//       }

//       setTableData((prevData: any) =>
//         prevData.map((pre: any) =>
//           pre.user_id === newd ? { ...pre, is_approved: newdstatus } : pre
//         )
//       );
//     } catch (error) {
//       // if (error) {
//       //   enqueueSnackbar(error, { variant: 'error' });
//       // } else {
//       //   enqueueSnackbar('Something went wrong. Please try again later', { variant: 'error' });
//       // }
//     }
//   };
//   const [searchusername, setSearchusername] = useState('');
//   const [searchemail, setSearchemail] = useState('');

//   // const handlereset = async () => {
//   //   if (facilitydata.length) {
//   //     setTableData(facilitydata);
//   //     setSearchusername('');
//   //     setSearchemail('');
//   //   }
//   // };
//   const handleChangeusername = (event: any) => {
//     setSearchusername(event.target.value);
//   };

//   const handleuserclick = async (e: any) => {
//     e.preventDefault();
//     // console.log('user', searchusername);
//     try {
//       const res = await axiosInstance.get(
//         `${endpoints.facility.getfacility}?q=${searchusername}&column_name=username&order=asc&column_type=string`
//       );

//       const details = res.data.results;
//       if (details.length) {
//         setTableData(details);
//         // Reset page to 0 after updating tableData
//         table.onResetPage();
//         // table.onChangePage(null, 0)
//         console.log('vbxmcvbxcb', res.data.total);
//         setFilterdata(res.data.total);
//       } else {
//         setTableData([]);
//       }
//     } catch (error) {
//       // Handle error
//     } finally {
//       setNewshowdata(true);
//     }
//   };

//   useEffect(() => {
//     if (newshowdata) {
//       table.onResetPage();

//       setNewshowdata(false);
//     }
//   }, [newshowdata, table]);

//   // useEffect(() => {
//   //   if (newshowdata && searchusername !== '') {
//   //     const filteredData = facilitydata.filter((row) =>
//   //       row.username.toLowerCase().includes(searchusername.toLowerCase()) ||
//   //       row.email.toLowerCase().includes(searchusername.toLowerCase())
//   //     );
//   //     setTableData(filteredData);
//   //   }
//   // }, [newshowdata, searchusername, facilitydata]);

//   useEffect(() => {
//     if (newshowdata && searchusername !== '') {
//       setTableData(tableData);
//     }
//   }, [newshowdata, searchusername, tableData]);

//   const handlecross = async () => {
//     setSearchusername('');
//     setTableData(facilitydata);
//   };
//   const handleSort = async (property: string) => {
//     const isAsc = orderBy === property && order === 'asc';
//     const newOrder: SortDirection = isAsc ? 'desc' : 'asc';
//     setOrder(newOrder);
//     setOrderBy(property);
//     setSorting(true);
//     try {
//       const res = await axiosInstance.get(
//         `${endpoints.facility.getfacility}?q&column_name=username&order=${newOrder}&column_type=string&page=${table.page + 1}`
//       );
//       const details = res.data.results;
//       // Calculate the updated tableData
//       const startIndex = table.page * table.rowsPerPage;
//       const endIndex = Math.min(startIndex + table.rowsPerPage, startIndex + details.length);
//       const updatedTableData = [
//         ...tableData.slice(0, startIndex),
//         ...details.slice(0, endIndex - startIndex),
//         ...tableData.slice(endIndex),
//       ];
//       // Update the state using the calculated data
//       setTableData(updatedTableData);
//     } catch (error) {
//       console.error('Error:', error);
//     } finally {
//       setSorting(false);
//       setNeworderdata(true);
//     }
//   };

//   // const handleSort = (property: string) => {
//   //   const isAsc = orderBy === property && order === 'asc';
//   //   const newOrder: SortDirection = isAsc ? 'desc' : 'asc';
//   //   setOrder(newOrder);
//   //   setOrderBy(property);
//   //   axiosInstance
//   //     .get(
//   //       `${endpoints.facility.getfacility}?q&column_name=username&order=${newOrder}&column_type=string`
//   //     )
//   //     .then((res) => {
//   //       const details = res.data.results;
//   //       console.log('details', details);
//   //       if (details.length) {
//   //         setTableData(details);
//   //       } else {
//   //         setTableData([]);
//   //       }
//   //     })
//   //     .catch((error) => {
//   //       // Handle the error if needed
//   //       // if (error) {
//   //       //   enqueueSnackbar(error, { variant: 'error' });
//   //       // } else {
//   //       //   enqueueSnackbar('Something went wrong. Please try again later', { variant: 'error' });
//   //       // }
//   //     });
//   // };
//   return (
//     <>
//       <Container maxWidth={settings.themeStretch ? false : 'lg'}>
//         <CustomBreadcrumbs
//           heading="Facilities"
//           links={[{}]}
//           sx={{
//             // mb: { xs: 1, md: 1 },
//             mb: 0,
//           }}
//         />
//         <Stack sx={{ flexDirection: 'row', paddingBottom: '12px' }}>
//           <Box
//             sx={{
//               p: '2px 4px',
//               display: 'flex',
//               alignItems: 'center',
//               width: 300,
//               height: 45,
//               border: '1px solid gray',
//               borderRadius: '15px',
//               marginRight: '10px',
//             }}
//           >
//             <InputBase
//               sx={{ ml: 1, flex: 1 }}
//               placeholder="Search Username/Email"
//               value={searchusername}
//               onChange={handleChangeusername}
//               inputProps={{ 'aria-label': 'search google maps' }}
//             />
//             {searchusername ? (
//               <>
//                 <IconButton
//                   type="button"
//                   onClick={handlecross}
//                   sx={{ p: '10px' }}
//                   aria-label="search"
//                 >
//                   <Iconify icon="basil:cross-solid" />
//                 </IconButton>
//               </>
//             ) : (
//               <></>
//             )}

//             <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
//             <IconButton
//               type="button"
//               onClick={handleuserclick}
//               sx={{ p: '10px' }}
//               aria-label="search"
//             >
//               <SearchIcon />
//             </IconButton>
//           </Box>

//           {/* <Box sx={{ marginTop: 'auto' }}>
//             <Button onClick={handlereset}>Clear</Button>
//           </Box> */}
//         </Stack>
//         <Card>
//           <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
//             <Scrollbar sx={{ maxHeight: 600 }}>
//               <Table stickyHeader size={table.dense ? 'medium' : 'small'} sx={{ minWidth: 960 }}>
//                 {/* <TableHeadCustom
//                   order={table.order}
//                   orderBy={table.orderBy}
//                   headLabel={TABLE_HEAD}
//                   rowCount={tableData.length}
//                   numSelected={table.selected.length}
//                   onSort={table.onSort}
//                   onSelectAllRows={(checked) =>
//                     table.onSelectAllRows(
//                       checked,
//                       tableData.map((row) => row.user_id)
//                     )
//                   }
//                 /> */}
//                 <TableHead>
//                   <TableRow>
//                     {TABLE_HEAD.map((headCell) => (
//                       <TableCell
//                         key={headCell.id}
//                         sortDirection={orderBy === headCell.id ? order : false}
//                         sx={{ backgroundColor: '#5da5da', color: 'white', backgroundImage: 'none' }}
//                       >
//                         <TableSortLabel
//                           active={orderBy === headCell.id}
//                           direction={orderBy === headCell.id ? order : undefined}
//                           onClick={() => handleSort(headCell.id)}
//                           sx={{
//                             '&:hover, &.MuiTableSortLabel-root.Mui-active,&.MuiTableSortLabel-focus':
//                               {
//                                 color: 'white', // Set the hover and active color to white
//                                 '.MuiTableSortLabel-icon': {
//                                   color: 'white', // Set the arrow icon color to white
//                                 },
//                               },
//                           }}
//                         >
//                           {headCell.label}
//                         </TableSortLabel>
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {productsLoading ? (
//                     [...Array(table.rowsPerPage)].map((i, index) => (
//                       <TableSkeleton key={index} sx={{ height: denseHeight }} />
//                       // <TableSkeleton sx={{ height: denseHeight }} />
//                     ))
//                   ) : (
//                     <>
//                       {tableData
//                         .slice(
//                           table.page * table.rowsPerPage,
//                           table.page * table.rowsPerPage + table.rowsPerPage
//                         )
//                         .map((row, index) => {
//                           const rowIndex = table.page * table.rowsPerPage + index + 1;
//                           return (
//                             <FacilityTable
//                               key={row.user_id}
//                               index={index}
//                               row={row}
//                               selected={table.selected.includes(row.user_id)}
//                               onSelectRow={() => table.onSelectRow(row.user_id)}
//                               onDeleteRow={() => handleDeleteRow(row.user_id)}
//                               onEditRow={() => handleEditRow(row.user_id)}
//                               onViewRow={() => handleViewRow(row.user_id)}
//                               onUpdateStatus={() => handleupdatestatus(row.user_id, row.user_type)}
//                             />
//                           );
//                         })}
//                     </>
//                   )}
//                   {/* <TableEmptyRows
//                     height={denseHeight}
//                     emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
//                   /> */}
//                   <TableNoData notFound={notFound} />
//                 </TableBody>
//               </Table>
//             </Scrollbar>
        
//           </TableContainer>

//           {/* <TablePaginationCustom
//             count={searchusername ? Number(filterdata) :  Number(total)}
//             page={table.page}
//             rowsPerPage={table.rowsPerPage}
//             onPageChange={table.onChangePage}
//             onRowsPerPageChange={table.onChangeRowsPerPage}
//             dense={table.dense}
//             onChangeDense={table.onChangeDense}
//           /> */}

//           <TablePaginationCustom
//             count={searchusername ? Number(filterdata) : Number(total)}
//             page={table.page}
//             rowsPerPage={table.rowsPerPage}
//             onPageChange={(event, newPage) => {
//               if (!sorting) {
//                 table.onChangePage(event, newPage);
//               }
//             }}
//             onRowsPerPageChange={table.onChangeRowsPerPage}
//             dense={table.dense}
//             onChangeDense={table.onChangeDense}
//           />
//         </Card>
//       </Container>

//       <ConfirmDialog
//         open={confirm.value}
//         onClose={confirm.onFalse}
//         title="Delete"
//         content={
//           <>
//             Are you sure want to delete <strong> {table.selected.length} </strong> items?
//           </>
//         }
//         action={
//           <Button
//             variant="contained"
//             color="error"
//             onClick={() => {
//               confirm.onFalse();
//             }}
//           >
//             Delete
//           </Button>
//         }
//       />
//     </>
//   );
// }

// // ----------------------------------------------------------------------

// function applyFilter({
//   inputData,
//   comparator,
//   filters,
// }: {
//   inputData: facility[];
//   comparator: (a: any, b: any) => number;
//   filters: IUserTableFilters;
// }) {
//   const { name, status, role } = filters;

//   const stabilizedThis = inputData.map((el, index) => [el, index] as const);

//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });

//   inputData = stabilizedThis.map((el) => el[0]);

//   return inputData;
// }




import isEqual from 'lodash/isEqual';
import { useState, useCallback, useEffect, useContext, useRef } from 'react';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TableContainer from '@mui/material/TableContainer';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { useGetFacility } from 'src/api/facilityapi';
import { useBoolean } from 'src/hooks/use-boolean';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
  useTable,
  TableNoData,
  TableSkeleton,
  TablePaginationCustom,
} from 'src/components/table';
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Stack,
} from '@mui/material';
import { IUserTableFilters } from 'src/types/user';
import { useSnackbar } from 'notistack';
import TableBody from '@mui/material/TableBody';
import { facility } from 'src/types/product';
import FacilityTable from 'src/sections/product/view/facility-table-row';
import axiosInstance, { endpoints } from 'src/utils/axios';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { errorMsg, modules, permissions } from 'src/api/constant';
import { AuthContext } from 'src/auth/context/jwt';
import { Box } from '@mui/system';
import 'src/css/style.css';
import Iconify from 'src/components/iconify/iconify';

const TABLE_HEAD = [
  { id: 'name',   label: 'Name',            column_name: 'name',  column_type: 'string', sortable: true  },
  { id: 'email',  label: 'Email',           column_name: 'email', column_type: 'string', sortable: true  },
  { id: 'created_at',   label: 'Start Date',      column_name: 'created_at',  column_type: 'string', sortable: true  },
  { id: 'action', label: 'Inactive/Active', column_name: '',      column_type: '',       sortable: false },
] as const;

type ColId = (typeof TABLE_HEAD)[number]['id'];
type SortDirection = 'asc' | 'desc';

const defaultFilters: IUserTableFilters = {
  name: '',
  role: [],
  status: 'all',
};

export default function AppUserFacilityView() {
  const table = useTable();
  const { enqueueSnackbar } = useSnackbar();
  const settings = useSettingsContext();
  const { user } = useContext(AuthContext);
  const users = user ?? null;
  const router = useRouter();

  // ── Sort state ──────────────────────────────────────────────────────────────
  const [order,   setOrder]   = useState<SortDirection>('asc');
  const [orderBy, setOrderBy] = useState<ColId | undefined>(undefined);

  // ── Search state ────────────────────────────────────────────────────────────
  const [searchusername, setSearchusername] = useState('');

  // ── Mode flags ──────────────────────────────────────────────────────────────
  const [isSearchMode, setIsSearchMode] = useState(false);

  // ── Table data & total ──────────────────────────────────────────────────────
  const [tableData,  setTableData]  = useState<facility[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading,    setLoading]    = useState(false);

  const confirm = useBoolean();
  const [filters] = useState(defaultFilters);

  // ── Refs: always hold latest values to avoid stale closures ────────────────
  const orderRef         = useRef<SortDirection>('asc');
  const orderByRef       = useRef<ColId | undefined>(undefined);
  const searchRef        = useRef<string>('');
  const isModeRef        = useRef<boolean>(false);
  const isOnlySearchRef  = useRef<boolean>(false); // true = pure search, false = sort (or sort+search)

  // Keep refs in sync with state
  useEffect(() => { orderRef.current   = order;          }, [order]);
  useEffect(() => { orderByRef.current = orderBy;        }, [orderBy]);
  useEffect(() => { searchRef.current  = searchusername; }, [searchusername]);
  useEffect(() => { isModeRef.current  = isSearchMode;   }, [isSearchMode]);

  // ── Default paginated fetch (used when NOT in search/sort mode) ─────────────
  const { facilitydata, productsLoading, total } = useGetFacility(table.page + 1);

  useEffect(() => {
    if (!isSearchMode && facilitydata?.length) {
      if (table.page === 0) {
        setTableData(facilitydata);
      } else {
        setTableData((prev) => [...prev, ...facilitydata]);
      }
      setTotalCount(Number(total));
    }
  }, [facilitydata, table.page, isSearchMode, total]);

  // ── Search fetch: column_name always 'username' ─────────────────────────────
  const fetchSearchData = useCallback(async (q: string, page: number) => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `${endpoints.facility.getfacility}` +
          `?q=${encodeURIComponent(q)}` +
          `&column_name=username` +   // ✅ always username for search
          `&order=asc` +
          `&column_type=string` +
          `&page=${page}`
      );
      setTableData(res.data.results ?? []);
      setTotalCount(Number(res.data.total ?? 0));
    } catch (err) {
      console.error('Search error:', err);
      setTableData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  // ── Sort fetch: column_name dynamic from refs ───────────────────────────────
  const fetchSortData = useCallback(async (page: number) => {
    const currentOrderBy = orderByRef.current;
    const currentOrder   = orderRef.current;
    const currentSearch  = searchRef.current;

    const headCell   = TABLE_HEAD.find((h) => h.id === currentOrderBy);
    const columnName = headCell?.column_name ?? 'name';
    const columnType = headCell?.column_type ?? 'string';

    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `${endpoints.facility.getfacility}` +
          `?q=${encodeURIComponent(currentSearch)}` +
          `&column_name=${columnName}` +  // ✅ dynamic column for sort
          `&order=${currentOrder}` +
          `&column_type=${columnType}` +
          `&page=${page}`
      );
      setTableData(res.data.results ?? []);
      setTotalCount(Number(res.data.total ?? 0));
    } catch (err) {
      console.error('Sort error:', err);
      setTableData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  // ── Sort handler ────────────────────────────────────────────────────────────
  const handleSort = useCallback(
    (colId: ColId) => {
      const headCell = TABLE_HEAD.find((h) => h.id === colId);
      if (!headCell || !headCell.sortable) return;

      const isAsc = orderBy === colId && order === 'asc';
      const newDir: SortDirection = isAsc ? 'desc' : 'asc';

      // Update state and refs immediately
      setOrder(newDir);
      setOrderBy(colId);
      setIsSearchMode(true);
      orderRef.current      = newDir;
      orderByRef.current    = colId;
      isModeRef.current     = true;
      isOnlySearchRef.current = false; // ✅ this is sort mode, not pure search

      table.onResetPage();
      fetchSortData(1);
    },
    [order, orderBy, fetchSortData, table]
  );

  // ── Search handler ──────────────────────────────────────────────────────────
  const handleuserclick = useCallback(
    (e: React.MouseEvent | React.FormEvent) => {
      e.preventDefault();
      if (!searchusername.trim()) return;

      setIsSearchMode(true);
      isModeRef.current       = true;
      isOnlySearchRef.current = true;  // ✅ pure search mode
      searchRef.current       = searchusername.trim();

      table.onResetPage();
      fetchSearchData(searchusername.trim(), 1);
    },
    [searchusername, fetchSearchData, table]
  );

  // ── Clear search ────────────────────────────────────────────────────────────
  const handlecross = useCallback(() => {
    setSearchusername('');
    setIsSearchMode(false);
    setOrder('asc');
    setOrderBy(undefined);
    orderRef.current        = 'asc';
    orderByRef.current      = undefined;
    searchRef.current       = '';
    isModeRef.current       = false;
    isOnlySearchRef.current = false;

    if (facilitydata?.length) {
      setTableData(facilitydata);
      setTotalCount(Number(total));
    }
    table.onResetPage();
  }, [facilitydata, total, table]);

  // ── Pagination ──────────────────────────────────────────────────────────────
  const handlePageChange = useCallback(
    (event: unknown, newPage: number) => {
      table.onChangePage(event, newPage);

      if (isModeRef.current) {
        if (isOnlySearchRef.current) {
          // ✅ pure search pagination — always use username
          fetchSearchData(searchRef.current, newPage + 1);
        } else {
          // ✅ sort pagination — use dynamic column from refs
          fetchSortData(newPage + 1);
        }
      }
    },
    [fetchSearchData, fetchSortData, table]
  );

  // ── Derived ─────────────────────────────────────────────────────────────────
  const dataInPage = tableData.slice(
    table.page * table.rowsPerPage,
    table.page * table.rowsPerPage + table.rowsPerPage
  );

  const denseHeight = table.dense ? 52 : 72;
  const notFound    = !loading && !productsLoading && tableData.length === 0;
  const isLoading   = loading || productsLoading;

  // ── Row actions ─────────────────────────────────────────────────────────────
  const handleDeleteRow = useCallback(
    (id: string) => {
      setTableData((prev) => prev.filter((row) => row.user_id !== id));
      table.onUpdatePageDeleteRow(dataInPage.length);
    },
    [dataInPage.length, table]
  );

  const handleViewRow = useCallback(
    (id: string) => router.push(paths.dashboard.user.viewfacilityappuserdetails(id)),
    [router]
  );

  const handleEditRow = useCallback(
    (id: string) => router.push(paths.dashboard.user.editfacilityappuserdetails(id)),
    [router]
  );

  const handleupdatestatus = async (id: any, user_type: any) => {
    if (!users) { enqueueSnackbar('Something went wrong', { variant: 'error' }); return; }
    if (!users[modules.account_type_facility].includes(permissions.UPDATE)) {
      enqueueSnackbar(errorMsg, { variant: 'error' }); return;
    }
    try {
      const res        = await axiosInstance.put(
        `${endpoints.facility.statusfacility}?user_id=${id}&user_type=${user_type}`
      );
      const details    = res.data.results;
      const newd       = JSON.parse(details.map((i: any) => i.user_id));
      const newdstatus = JSON.parse(details.map((i: any) => i.is_approved));

      enqueueSnackbar(
        newdstatus
          ? 'Account activated. All related account types are now active.'
          : 'Account deactivated. All related account types are now inactive.'
      );
      setTableData((prev) =>
        prev.map((row) => (row.user_id === newd ? { ...row, is_approved: newdstatus } : row))
      );
    } catch (error) {
      enqueueSnackbar('Something went wrong. Please try again later.', { variant: 'error' });
    }
  };

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs heading="Facilities" links={[{}]} sx={{ mb: 0 }} />

        {/* Search bar */}
        <Stack sx={{ flexDirection: 'row', paddingBottom: '12px' }}>
          <Box
            component="form"
            onSubmit={handleuserclick}
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              width: 300,
              height: 45,
              border: '1px solid gray',
              borderRadius: '15px',
              marginRight: '10px',
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Username/Email"
              value={searchusername}
              onChange={(e) => setSearchusername(e.target.value)}
              inputProps={{ 'aria-label': 'search facilities' }}
            />
            {searchusername && (
              <IconButton type="button" onClick={handlecross} sx={{ p: '10px' }} aria-label="clear">
                <Iconify icon="basil:cross-solid" />
              </IconButton>
            )}
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Box>
        </Stack>

        {/* Table */}
        <Card>
          <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
            <Scrollbar sx={{ maxHeight: 600 }}>
              <Table stickyHeader size={table.dense ? 'medium' : 'small'} sx={{ minWidth: 960 }}>

                {/* Head */}
                <TableHead>
                  <TableRow>
                    {TABLE_HEAD.map((headCell) => (
                      <TableCell
                        key={headCell.id}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ backgroundColor: '#5da5da', color: 'white', backgroundImage: 'none' }}
                      >
                        {headCell.sortable ? (
                          <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={() => handleSort(headCell.id as ColId)}
                            sx={{
                              '&:hover, &.MuiTableSortLabel-root.Mui-active, &.MuiTableSortLabel-focus': {
                                color: 'white',
                                '.MuiTableSortLabel-icon': { color: 'white' },
                              },
                            }}
                          >
                            {headCell.label}
                          </TableSortLabel>
                        ) : (
                          headCell.label
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                {/* Body */}
                <TableBody>
                  {isLoading ? (
                    [...Array(table.rowsPerPage)].map((_, index) => (
                      <TableSkeleton key={index} sx={{ height: denseHeight }} />
                    ))
                  ) : (
                    (isSearchMode
                      ? tableData
                      : tableData.slice(
                          table.page * table.rowsPerPage,
                          table.page * table.rowsPerPage + table.rowsPerPage
                        )
                    ).map((row, index) => (
                      <FacilityTable
                        key={row.user_id}
                        index={index}
                        row={row}
                        selected={table.selected.includes(row.user_id)}
                        onSelectRow={() => table.onSelectRow(row.user_id)}
                        onDeleteRow={() => handleDeleteRow(row.user_id)}
                        onEditRow={() => handleEditRow(row.user_id)}
                        onViewRow={() => handleViewRow(row.user_id)}
                        onUpdateStatus={() => handleupdatestatus(row.user_id, row.user_type)}
                      />
                    ))
                  )}
                  <TableNoData notFound={notFound} />
                </TableBody>

              </Table>
            </Scrollbar>
          </TableContainer>

          <TablePaginationCustom
            count={totalCount}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={table.onChangeRowsPerPage}
            dense={table.dense}
            onChangeDense={table.onChangeDense}
          />
        </Card>
      </Container>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={<>Are you sure want to delete <strong>{table.selected.length}</strong> items?</>}
        action={
          <Button variant="contained" color="error" onClick={() => confirm.onFalse()}>
            Delete
          </Button>
        }
      />
    </>
  );
}